import { Component, HostListener, NgZone, ViewChild } from '@angular/core';
import { MatMenuTrigger } from '@angular/material/menu';
import { Router } from '@angular/router';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent {
  isSticky = true;
  isHidden = false;
  isScrolled = false;
  private hideNavTimeout: any;
  isMenuVisible = false;
  screenWidth: number = window.innerWidth;
  screenHeight: number = window.innerHeight;
  isHoveringMenu = false;
  isHoveringButton = false;
  closeMenuTimeout: any;

  @ViewChild('featuresTrigger') featuresMenuTrigger!: MatMenuTrigger;

  features = [
    { name: 'SEO', link: '/seo' },
    { name: 'UI UX', link: '/UI-UX' },
    { name: 'Graphic Design', link: '/graphic-editing' },
    { name: 'Web Development', link: '/website-development' },
    { name: 'Video Editing', link: '/video-editing' },
    { name: 'Digital Marketing', link: '/digital-marketing' }
  ];

  constructor(private ngZone: NgZone, private router: Router) {
    window.onresize = () => {
      this.screenWidth = window.innerWidth;
      this.screenHeight = window.innerHeight;
    };
  }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    const scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
    this.isScrolled = scrollPosition > 50;

    if (scrollPosition === 0) {
      this.isHidden = false;
      clearTimeout(this.hideNavTimeout);
    } else {
      clearTimeout(this.hideNavTimeout);
      this.isSticky = true;
      this.isHidden = false;
      this.hideNavTimeout = setTimeout(() => {
        this.isSticky = true;
        this.isHidden = true;
      }, 3000);
    }
  }

  scrollTo(sectionId: string) {
    this.ngZone.runOutsideAngular(() => {
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        } else {
          // If the element isn't found, navigate to the homepage (or the correct page)
          this.router.navigate(['/Home']).then(() => {
            // Give the page time to load the element
            setTimeout(() => {
              const newElement = document.getElementById(sectionId);
              if (newElement) {
                newElement.scrollIntoView({ behavior: 'smooth' });
              }
            }, 50);
          });
        }
      }, 50);
    });
  }


  toggleMenu() {
    this.isMenuVisible = !this.isMenuVisible;
  }

  showFeaturesMenu() {
    clearTimeout(this.closeMenuTimeout);
    this.isHoveringButton = true;
    this.featuresMenuTrigger.openMenu();
  }

  hideFeaturesMenu() {
    this.isHoveringButton = false;
    this.startCloseTimer();
  }

  setHoverState(state: boolean) {
    this.isHoveringMenu = state;
    if (!state) {
      this.startCloseTimer();
    } else {
      clearTimeout(this.closeMenuTimeout);
    }
  }

  startCloseTimer() {
    this.closeMenuTimeout = setTimeout(() => {
      if (!this.isHoveringButton && !this.isHoveringMenu) {
        this.featuresMenuTrigger.closeMenu();
      }
    }, 1000);
  }
}
